module.exports = __webpack_public_path__ + "6f4609e8a4614535313342afe7333be8.jpg";